/* eslint class-methods-use-this: 0 */
import moment from 'moment';
import * as algoliasearch from 'algoliasearch/lite';

import TettraResource from './TettraResourceAbstractSchema';
import { ICON, RESOURCE_TYPE, SEARCH_INDEX } from '../utilities/CONSTANTS';
import { FONT_ICON } from '../tettra-editor/utilities/CONSTANTS';
import { getQuestionUrl } from '../utilities/urlHelper';

class TettraQuestion extends TettraResource {
    constructor(data) {
        super(data);
        this.data = this.constructor.transformData(data);
        this.id = this.data.id;
        this.type = RESOURCE_TYPE.TETTRA_QUESTION;
    }

    static transformData(data) {
        const {
            objectID,
            title,
            category_id,
            last_updated,
        } = data;
        const id = parseInt(objectID, 10);
        const url = getQuestionUrl(id);

        return ({
            id, title, last_updated, category_id, url,
        });
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.data.title;
    }

    getSubtitle() {
        return moment.unix(this.data.last_updated).fromNow();
    }

    getIcon() {
        // TODO: update based on if question is opened or closed
        return ICON.QUESTION;
    }

    getCustomClass() {
        return 'tettra-question';
    }

    getUrl() {
        return this.data.url;
    }

    getEntityData() {
        const referenceType = RESOURCE_TYPE.TETTRA_QUESTION;
        const {
            id, title, url, category_id, last_updated,
        } = this.data;

        return ({
            referenceType,
            title,
            url,
            id,
            metadata: {
                category_id,
                last_updated,
            },
        });
    }

    getFontIcon() {
        // TODO: update based on if question is opened or closed
        // also update fontmoon font icon

        return FONT_ICON.TETTRA_QUESTION;
    }

    isInternal() {
        return true;
    }

    static FromEntityData({ id, title, metadata }) {
        return new TettraQuestion({
            objectID: id,
            title,
            category_id: metadata.category_id,
            last_updated: metadata.last_updated,
        });
    }

    static Search(searchQuery, maxSuggestions = 10) {
        if (!window.algoliaAppId || !window.algoliaSearchKey) return null;

        const client = algoliasearch(window.algoliaAppId, window.algoliaSearchKey);
        const index = client.initIndex(SEARCH_INDEX);

        const searchParams = {
            hitsPerPage: maxSuggestions,
            attributesToRetrieve: ['objectID', 'title', 'last_updated', 'url', 'category_id'],
        };

        return new Promise((resolve, reject) => {
            index.search(searchQuery, searchParams)
                .then(({ hits }) => resolve(hits.map((data) => (new TettraQuestion(data)))))
                .catch(reject);
        });
    }
}

export default TettraQuestion;
